<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Estado</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="status"
                        class="form-control"
                        placeholder="Estado"
                        disabled
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Nombre</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="name"
                        class="form-control"
                        placeholder="Nombre"
                        disabled
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Correo electrónico</label
                >
                <div class="col-md-9">
                    <input
                        type="email"
                        v-model="email"
                        class="form-control"
                        placeholder="Correo electronico"
                        disabled
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Teléfono</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="phone"
                        class="form-control"
                        placeholder="Telefono"
                        disabled
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Resumen</label
                >
                <div class="col-md-9">
                    <textarea
                        v-model="summary"
                        class="form-control"
                        name="summary"
                        rows="3"
                        placeholder="Resumen"
                        disabled
                    ></textarea>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >IP</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="ip"
                        class="form-control"
                        placeholder="I.P"
                        disabled
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Fecha</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="created_at"
                        class="form-control"
                        placeholder="Fecha"
                        disabled
                    />
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="showContacted"
                    type="button"
                    @click="toggleStatus(0, showContacted)"
                    class="btn btn-primary"
                >
                    Marcar como contactado
                </button>
                <button
                    v-if="showNotContacted"
                    type="button"
                    @click="toggleStatus(1, showNotContacted)"
                    class="btn btn-primary"
                >
                    Marcar como no contactado
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import moment from "moment";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            action: "",
            summary: null,
            name: null,
            email: null,
            phone: null,
            status: null,
            created_at: null,
            ip: null,
            showContacted: false,
            showNotContacted: false,
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/doubts/show/" + me.model_id)
                .then(function (response) {
                    me.name = response.data.model.name;
                    me.summary = response.data.model.summary;
                    me.email = response.data.model.email;
                    me.phone = response.data.model.phone;
                    me.status = response.data.model.status;
                    me.ip = response.data.model.ip;
                    me.created_at = me.filterDate(
                        response.data.model.created_at
                    );
                    me.showContacted = response.data.showContacted;
                    me.showNotContacted = response.data.showNotContacted;
                })
                .catch(function (error) {});
        },
        filterDate(value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm");
            }
            return null;
        },
        toggleStatus(field, value) {
            let me = this;
            if (field == 0) {
                me.showContacted = !value;
            } else {
                me.showNotContacted = !value;
            }
            axios
                .put("/api/doubts/toggle-status/" + me.model_id)
                .then(function (response) {
                    me.showContacted = response.data.showContacted;
                    me.showNotContacted = response.data.showNotContacted;
                    me.status = response.data.status;
                    me.showActionSuccess("Actualizacion de estado exitosa!");
                })
                .catch(function (error) {});
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        this.getModel();
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
